import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon
} from '../../components'
import Styles from './FamilyGrid.css'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  renderCompanies = () => {
    return config.familyFunds.map((c,idx) =>{
      return this.renderCompany(
        idx,
        c.fund_family_name,
        c.ff_all_asset_sum,
        c.ff_all_weight_total,
        c.num_equity_funds,
        4
      )
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      // console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  renderCompany = (idx, title, asset, perc, numFunds, rating) => {
    const safeName = encodeURIComponent(title)
    return(
      <div key={idx} styleName='companies-box-wrap'>
        <Link
          to={config.links.fff + '/families?q=' + safeName}
          styleName='companies-link'
          title={title}
        >
          <div styleName={'companies-box-'+rating}>
            <div styleName='box-title-wrapper'>
              { this.renderLogo(title) }
            </div>
            <div styleName='box-subtitle'>
              {numFunds} funds analyzed
            </div>
            <div styleName='box-subtitle'>
              {format.perc(perc, true)} fossil fuel exposure
            </div>
            <div styleName='box-subtitle'>
              {format.money(asset, true, 'US Dollar', false, 0)}
              &nbsp;
              in fossil fuel stocks
            </div>
            <div styleName='learn-more-wrap'>
              <div styleName={'learn-more-'+rating}>
                More<LinkIcon />
              </div>
            </div>
          </div>
        </Link>
      </div>
    )
  }

  render() {
    return (
      <div styleName='companies-boxes'>
        { this.renderCompanies() }
      </div>
    )
  }
}
